import React from "react"
import { BrowserRouter, Switch, Route, Redirect, withRouter } from "react-router-dom"
import { Login } from "../pages/login"
import { Admin } from "../pages/admin"
import { PrivateRoute } from "./privateRoute";

function AppRoute() {
    return (
        <BrowserRouter>
            <Switch>
                <Route path="/login" component={Login} />
                <PrivateRoute path="/admin" component={Admin} />
                <Redirect from="*" to="/admin" />
            </Switch>
        </BrowserRouter>
    )
}

export { AppRoute }